import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from './auth.service';
import * as Global from 'src/app/global';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CustomService {
  constructor(
    private router: Router,
    private authService: AuthService,
    private toastr: ToastrService,
  ) {}
  public timer = new BehaviorSubject<any>('') ?? 0;
  public srolledposition = new BehaviorSubject<any>('') ?? 1;
  public ClearInterVal = new BehaviorSubject<any>(false);
  public submitBulkABP$ = new Subject<any>();
  public upladBulkABP$ = new Subject<any>();
  public onMarkedError$ = new Subject<any>();
  public updateUserProfile$ = new Subject<any>();
  public resetsellerCatalogue$ = new Subject<any>();

  submitBulkABP = this.submitBulkABP$.asObservable();
  upladBulkABP = this.upladBulkABP$.asObservable();

  public givenABP = new BehaviorSubject<any>('') ?? 0;

  public endindex = new BehaviorSubject<any>('') ?? 0;
  public startindex = new BehaviorSubject<any>('') ?? 0;

  // public dayShown = new BehaviorSubject<any>('') ?? 0;
  // public hourShown = new BehaviorSubject<any>('') ?? 0;
  //public calculatedminShown = new BehaviorSubject<number>(0) ?? 0;
  //public calculatedsecShown = new BehaviorSubject<number>(0) ?? 0;
  /**
   * ====================================================
   * HTTP Error Abort Functions
   * ====================================================
   * ====================================================
   * */
  abortError(errorcode: number, message: any = null) {
    switch (errorcode) {
      case 404:
        this.router.navigateByUrl('/error/404', { skipLocationChange: true });
        return true;

      case 401:
        this.router.navigateByUrl('/error/401', { skipLocationChange: true });
        return true;

      case 419:
        this.router.navigateByUrl(
          `/error/419?${message ? `message=${message}` : ``}`,
          { skipLocationChange: true },
        );
        return true;

      case 500:
        this.router.navigateByUrl(
          `/error/500?${message ? `message=${message}` : ``}`,
          { skipLocationChange: true },
        );
        return true;

      default:
        return false;
    }
  }

  /**
   * ====================================================
   * Handle Server Error Exceptions
   * ====================================================
   * ====================================================
   * */
  handleServerExceptions(exception: any) {
    if (exception.status == 401) {
      this.authService.userLogout();
      // this.toastr.error(Global.getServerErrorMessage(exception));
      return;
    }
  }
  triggerBulkABP(): void {
    this.submitBulkABP$.next('');
  }
  triggerUploadABP(): void {
    this.upladBulkABP$.next('');
  }
  ngOnDestroy(): void {}
}
